module.exports = __webpack_public_path__ + "img/p-two-step-14.a5eb3992.png";